(function() {

  'use strict';

  function AreaResource($resource, PUBLIC_API) {
    return $resource(PUBLIC_API + '/area-atendimento', {}, {
      verificarArea: {
        method: 'GET',
        params: {
          cep: '@cep'
        }
      }
    });
  };

  angular.module('mandaeApp')
    .factory('AreaResource', AreaResource);

})();
